import { merge } from 'lodash'

import acronyms from './acronyms.en.json'
import en from './en.json'
import formDefaults from './formDefaults.en.json'

export default merge(en, formDefaults, acronyms)
